var _filter, _image, _mask, _clipPath, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image7",
    width: 28,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAAABmJLR0QA/wD/AP+gvaeTAAAAq0lEQVRIie3VMQrCQBSE4dlsY2NrZWxFjJBKQdBLeAOvIAQvkYOoAWsLr5BOPEWUrBDEPBkL0cI6vmoH/vorBwDAKg9ZJxklchTLZosc6+We97SPLyazonnot+mFVR4a1kkGky6gs52hRA44t3W8kTMUSx3svUAT86AHPehBNXBw0+PiMgDHRz3wdAjwHK6ByfX/2LzAo7MC8Hl9u6XEZfNPH5eU1oZVrwsAL+/0Bej+0RDYAAAAAElFTkSuQmCC"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7"
  })))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface6",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    style: {
      fill: "rgb(9.803922%,74.901961%,74.901961%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14 17.335938 C 18.050781 17.335938 21.332031 14.050781 21.332031 10 C 21.332031 5.953125 18.050781 2.667969 14 2.667969 C 9.949219 2.667969 6.667969 5.953125 6.667969 10 C 6.667969 14.050781 9.949219 17.335938 14 17.335938 Z M 19.960938 10.667969 C 19.714844 12.90625 18.234375 14.773438 16.214844 15.578125 C 16.867188 14.253906 17.246094 12.53125 17.320312 10.667969 Z M 15.984375 10.667969 C 15.886719 12.917969 15.300781 14.90625 14.386719 15.988281 C 14.257812 15.996094 14.128906 16 14 16 C 13.871094 16 13.742188 15.996094 13.613281 15.988281 C 12.699219 14.90625 12.109375 12.917969 12.015625 10.667969 Z M 10.679688 10.667969 C 10.753906 12.53125 11.132812 14.253906 11.78125 15.578125 C 9.761719 14.773438 8.285156 12.90625 8.035156 10.667969 Z M 12.015625 9.335938 L 15.984375 9.335938 C 15.886719 7.085938 15.300781 5.097656 14.386719 4.011719 C 14.257812 4.003906 14.128906 4 14 4 C 13.871094 4 13.742188 4.003906 13.613281 4.011719 C 12.699219 5.097656 12.109375 7.085938 12.015625 9.335938 Z M 11.78125 4.425781 C 11.132812 5.75 10.753906 7.472656 10.679688 9.335938 L 8.035156 9.335938 C 8.285156 7.09375 9.761719 5.226562 11.78125 4.425781 Z M 19.960938 9.335938 L 17.320312 9.335938 C 17.246094 7.472656 16.867188 5.75 16.214844 4.425781 C 18.234375 5.226562 19.714844 7.09375 19.960938 9.335938 Z M 19.960938 9.335938 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4 0 L 24 0 C 26.210938 0 28 1.789062 28 4 L 28 16 C 28 18.210938 26.210938 20 24 20 L 4 20 C 1.789062 20 0 18.210938 0 16 L 0 4 C 0 1.789062 1.789062 0 4 0 Z M 4 0 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface6",
    mask: "url(#mask0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.cddc59020c2ee1afba1a61d3cb7639c7.svg";
export { ForwardRef as ReactComponent };